export enum MasteryLevel {
  Mastered = 'MASTERED',
  Developing = 'DEVELOPING',
  NeedsSupport = 'NEEDS_SUPPORT',
  NotAssessed = 'NOT_ASSESSED',
}
